export default __webpack_public_path__ + "static/media/info.ef81b6ab.png";